const portrait = "/images/michael-horgas-portrait.png";

export default function About() {
  return (
    <section
      id="ueber-mich"
      data-testid="about-section"
      className="border-b border-black/10 section-padding bg-white"
    >
      <div className="max-w-[1440px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-12 lg:gap-16 items-start">
          <div className="md:col-span-5">
            <div className="relative aspect-[4/5] overflow-hidden">
              <img
                src={portrait}
                alt="Michael Horgas — Portrait"
                className="w-full h-full object-cover"
                data-testid="about-portrait"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-[#0A0A0A] text-white p-5 flex items-center justify-between">
                <div>
                  <div className="font-display font-bold text-lg leading-none">
                    Michael Horgas
                  </div>
                  <div className="text-xs uppercase tracking-[0.2em] opacity-70 mt-1">
                    Consultant
                  </div>
                </div>
                <span className="text-xs font-mono opacity-70">02 / 03</span>
              </div>
            </div>
          </div>

          <div className="md:col-span-7 md:pl-2 lg:pl-8">
            <div className="overline mb-6">Über mich</div>
            <h2 className="font-display font-bold text-3xl sm:text-4xl md:text-5xl tracking-tight leading-[1.05]">
              Über drei Jahrzehnte
              <br />
              im Maschinenraum der
              <br />
              <span className="text-[#D30000]">Sparkassen und Leasinggesellschaften.</span>
            </h2>

            <div className="mt-8 space-y-5 text-base md:text-lg leading-relaxed text-[#4A4A52] max-w-2xl">
              <p>
                Bankausbildung bei der Haspa, seit 1988 durchgehend im Vertrieb
                für Leasing­gesellschaften — zuerst rund zehn Jahre im
                Außendienst, anschließend von 1996 bis 2026 Vertriebs­leitung
                mit Personal­verantwortung. Stationen: Hanseatische Leasing
                (1997) und über zwei Jahrzehnte Deutsche Leasing AG (bis 2026).
              </p>
              <p>
                Verantwortlich für Direkt- und Spezial­vertriebs­einheiten
                (NFZ, IT, Banken­vertrieb, Partner­vertrieb Agrar /
                Bau­maschinen / Vermittler), den Aufbau ganzer Zielmärkte sowie
                die Entwicklung von Vertriebs­strategien, Markt­bearbeitungs­konzepten
                und automatisierten Kredit­prozessen. Einstellung und
                Ausbildung von Innen- und Außen­dienst­mitarbeitern über die
                gesamte Zeit. Führungsspanne: 10–25 Mitarbeitende.
                Umsatzgrößen­ordnungen: ca. 200 Mio. €.
              </p>
              <p>
                <span className="font-medium text-[#0A0A0A]">Mein Mindset:</span>{" "}
                Der Investitions­finanzierer im Mittelstand ist austauschbar.
                Wenn man im Band der Anbieter konditionell mithält und/oder
                konzeptionell überzeugt, entscheidet der persönliche Eindruck.
                Den Bedarf des Kunden präzise zu erkennen — und den Verkauf
                als Dienstleistung zu denken — ist die Königs­disziplin.
                Genau darauf habe ich Teams ausgerichtet. Und genau darin
                begleite ich heute Führungs­kräfte und Vertriebs­mitarbeiter.
              </p>
            </div>

            <dl className="mt-12 grid grid-cols-1 sm:grid-cols-2 border-t border-black/10">
              <Cred title="Vertriebsleitung" value="1996 – 2026" />
              <Cred title="Im Leasing-Vertrieb seit" value="1988" border />
            </dl>

            <div className="mt-8 border-t border-black/10 pt-8">
              <div className="overline mb-4">Stationen</div>
              <ul className="space-y-3 text-sm md:text-base text-[#4A4A52]">
                <Station years="1979" label="Bankausbildung Haspa" />
                <Station years="1988 – 1995" label="Außendienst Leasing" />
                <Station years="1995" label="Vertriebsleitung Hanseatische Leasing GmbH" />
                <Station years="1997 – 2026" label="Vertriebsleitung Direkt- & Spezial­vertrieb · Deutsche Leasing AG" />
                <Station years="2026 – heute" label="Consulting · selbständig" />
              </ul>
            </div>

            <div className="mt-8 border-t border-black/10 pt-8 max-w-2xl">
              <div className="overline mb-3">Trainerqualifikationen</div>
              <p className="text-sm text-[#4A4A52]">
                Ausbildung über 15 Jahre in einem Manager­board durch
                zertifizierte Coaches — Schwer­punkte Personal­führung,
                Team­führung und Organisations­entwicklung.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Cred({ title, value, border }) {
  return (
    <div
      className={`py-6 ${border ? "sm:border-l border-black/10 sm:pl-6" : ""}`}
    >
      <div className="text-xs uppercase tracking-[0.2em] text-[#4A4A52]">
        {title}
      </div>
      <div className="font-display font-black text-2xl md:text-3xl mt-2 tracking-tighter">
        {value}
      </div>
    </div>
  );
}

function Station({ years, label }) {
  return (
    <li className="grid grid-cols-[120px_1fr] gap-4 border-t border-black/10 pt-3 first:border-t-0 first:pt-0">
      <span className="font-mono text-xs uppercase tracking-[0.18em] text-[#0A0A0A] pt-1">
        {years}
      </span>
      <span className="leading-relaxed">{label}</span>
    </li>
  );
}
